import { render, staticRenderFns } from "./TranslationSummaryBadge.vue?vue&type=template&id=335e9573&scoped=true&"
import script from "./TranslationSummaryBadge.vue?vue&type=script&lang=js&"
export * from "./TranslationSummaryBadge.vue?vue&type=script&lang=js&"
import style0 from "./TranslationSummaryBadge.vue?vue&type=style&index=0&id=335e9573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335e9573",
  null
  
)

export default component.exports